const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Assets",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.121,
    y: 2.121,
    width: 27.758,
    height: 27.758,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.694,15.483C27.171,12.409,21.83,8.822,16,8.822c-5.851,0-11.192,3.611-13.694,6.661a.815.815,0,0,0,0,1.035C4.889,19.666,10.243,23.179,16,23.179c5.962,0,11.281-3.72,13.694-6.661A.815.815,0,0,0,29.694,15.483ZM21.546,16A5.546,5.546,0,1,1,16,10.455,5.552,5.552,0,0,1,21.546,16ZM4.04,16a19.728,19.728,0,0,1,6.245-4.339,7.159,7.159,0,0,0,0,8.676A19.359,19.359,0,0,1,4.04,16Zm17.675,4.338a7.159,7.159,0,0,0,0-8.676A19.359,19.359,0,0,1,27.96,16,19.711,19.711,0,0,1,21.715,20.339Z",
    style: {
      fill: "#49b3b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.224,16A2.776,2.776,0,1,0,16,13.224,2.779,2.779,0,0,0,13.224,16Zm3.919,0A1.143,1.143,0,1,1,16,14.857,1.145,1.145,0,0,1,17.143,16Z",
    style: {
      fill: "#f2b42a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,5.659a.816.816,0,0,0,.816-.817v-1.9a.817.817,0,0,0-1.633,0v1.9A.817.817,0,0,0,16,5.659Z",
    style: {
      fill: "#49b3b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.871,6.752a.816.816,0,0,0,1.114-.3l1.086-1.905a.816.816,0,1,0-1.418-.809L20.567,5.639A.816.816,0,0,0,20.871,6.752Z",
    style: {
      fill: "#49b3b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.015,6.448a.816.816,0,0,0,1.418-.809L10.347,3.734a.816.816,0,1,0-1.418.809Z",
    style: {
      fill: "#49b3b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,26.342a.816.816,0,0,0-.817.816v1.9a.817.817,0,1,0,1.633,0v-1.9A.816.816,0,0,0,16,26.342Z",
    style: {
      fill: "#49b3b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.129,25.251a.816.816,0,0,0-1.114.3l-1.086,1.9a.817.817,0,1,0,1.418.81l1.086-1.906A.816.816,0,0,0,11.129,25.251Z",
    style: {
      fill: "#49b3b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.985,25.556a.816.816,0,1,0-1.418.808l1.086,1.906a.817.817,0,1,0,1.418-.81Z",
    style: {
      fill: "#49b3b1"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViews);
export default __webpack_public_path__ + "static/media/views.17000cda1b4127058a086bab466ab4ef.svg";
export { ForwardRef as ReactComponent };